import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SeriesService, Series, PaginatedResponse } from 'cms-post-lib';
import { environment } from '../../../environments/environment';

export interface SeriesListResolverData {
  series: PaginatedResponse<Series>;
}

export const seriesListResolver: ResolveFn<SeriesListResolverData> = (route: ActivatedRouteSnapshot) => {
  const seriesService = inject(SeriesService);
  const orgId = environment.orgId;
  const page = parseInt(route.queryParamMap.get('page') ?? '1', 10);

  return seriesService.getPublicSeries({ orgId, page, limit: 12 }).pipe(
    map(series => ({ series })),
    catchError(() =>
      of({
        series: {
          success: false,
          count: 0,
          data: [],
          pagination: { page: 1, limit: 12, total: 0, pages: 0 },
        } as unknown as PaginatedResponse<Series>,
      })
    )
  );
};
